<template>
  <div class="page-layout">
    <div class="page-content page-content--narrow">
      <h1>Форум</h1>
      <div class="panel">
        <p class="empty-state">Раздел форума находится в разработке и скоро будет доступен.</p>
      </div>
    </div>
  </div>
</template>
